// @ts-nocheck
 
 
 
/* eslint-disable react/self-closing-comp */
 
/* eslint-disable padding-line-between-statements, import/order, import/newline-after-import, spaced-comment */
/* eslint-disable @typescript-eslint/no-unused-vars */
 
 
/* eslint-disable react/jsx-newline */
/* eslint-disable react/button-has-type */
 
 
 

import axios from "axios";
import React, { Fragment, useEffect, useRef, useState , Suspense } from 'react'

import { Link, NavLink, useHistory } from "react-router-dom";
//import NavBar from '../components/NavBar';
import { ToastContainer, toast } from 'react-toastify';
import { useTranslation } from 'react-i18next'
import "../style.css";
//import Sidebar from '../components/Sidebar';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import AssistantDirectionIcon from '@mui/icons-material/AssistantDirection';
import BlurCircularIcon from '@mui/icons-material/BlurCircular';
import SearchIcon from '@mui/icons-material/Search';
import cookies from 'js-cookie'
import FilterAltIcon from '@mui/icons-material/FilterAlt';
import CloseIcon from '@mui/icons-material/Close';
import Loading from "../images/loading2.svg";
import {
  Button,
  CircularProgress,
  Popover,
  Typography,

  createStyles,
  Grid,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,

} from '@material-ui/core';

import { basicButtonStyles, tableRowStyles } from 'app/shared/styles';
import { TextCell } from 'app/components/shared/table';

import { default as ReactSelect , components } from "react-select";


import { Box } from '@mui/material';
import { useIntl } from 'react-intl';
import { useGetFilterOrganizations } from 'hooks';
import { useGetFilterGroups } from 'hooks/useGetFilterGroups';
import { useTypedSelector } from 'helpers';
import { useSelector } from 'react-redux';
import { log } from 'console';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { hasWriteAccessToMasterConfigSubSystem } from "selectors";
import OfflineShareIcon from '@mui/icons-material/OfflineShare';
import HelpOutlineIcon from '@mui/icons-material/HelpOutline';
const useStyles = makeStyles(() =>
  createStyles({
    table: { minWidth: 750, overflow: 'scroll', whiteSpace: 'nowrap' },
    addButton: { ...basicButtonStyles },
    row: { ...tableRowStyles },
  })
);

const TransferBalanceForm: React.FC = () => {
  const intl = useIntl();
  const classes = useStyles();
  const { t } = useTranslation()
  const history = useHistory();
  const currentLanguageCode = localStorage.getItem("EASY_MOBILITY_LANGUAGE") || 'en-us'

  // Auth data
  let loggedInUserPersonalData: any = '';
  let loggedInUserAccessTokenClientUid: any = '';
  const authData = localStorage.getItem("authData");
  if (authData !== null) {
    const parsedAuthData = JSON.parse(authData);
    loggedInUserPersonalData = parsedAuthData.userData;
    loggedInUserAccessTokenClientUid = parsedAuthData.userToken;
  }

  const hasWriteAccess = useTypedSelector(state =>
    hasWriteAccessToMasterConfigSubSystem(state, 'TransferBalance')
  );

  // Form states
  const [fromCardSerial, setFromCardSerial] = useState('');
  const [toCardSerial, setToCardSerial] = useState('');
  const [fromCardInfo, setFromCardInfo] = useState<any>(null);
  const [toCardInfo, setToCardInfo] = useState<any>(null);
  // v8: two independent checkboxes replaced by one explicit mode — the DB derives
  // "replacement" from use_all_balance + make_from_card_blacklisted together, so the
  // UI now expresses that same pairing as a single choice instead of two toggles.
  const [mode, setMode] = useState<'balance' | 'replacement'>('balance');
  const [blacklistNote, setBlacklistNote] = useState('');
  const [wantedAmount, setWantedAmount] = useState('');
  const [isLoadingFrom, setIsLoadingFrom] = useState(false);
  const [isLoadingTo, setIsLoadingTo] = useState(false);
  const [isTransferring, setIsTransferring] = useState(false);

  // Get card info function
  const getCardInfo = async (serial: string, isFromCard: boolean) => {
    if (!serial.trim()) {
      toast.error(intl.formatMessage({ id: 'PleaseEnterCardSerial' }) || 'Please enter card serial', {
        position: "top-right",
        autoClose: 3000,
      });
      return;
    }

    if (isFromCard) {
      setIsLoadingFrom(true);
    } else {
      setIsLoadingTo(true);
    }

    try {
      const url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/transactions/transfer_balance_inquery`;
      const response = await axios.post(url, {
        fare_media_serial: serial.trim()
      }, {
        headers: {
          'access-token': loggedInUserAccessTokenClientUid['access-token'],
          'uid': loggedInUserAccessTokenClientUid?.uid,
          'client': loggedInUserAccessTokenClientUid?.client,
        },
      });

      if (response.data.success) {
        if (response.data.data.exist) {
          if (isFromCard) {
            setFromCardInfo(response.data.data);
          } else {
            setToCardInfo(response.data.data);
          }
          /* toast.success(intl.formatMessage({ id: 'CardInfoRetrievedSuccessfully' }) || 'Card info retrieved successfully', {
             position: 'top-right',
             autoClose: 3000,
           });*/
        } else {
          toast.error(intl.formatMessage({ id: 'CardDoesNotExist' }) || 'Card does not exist', {
            position: 'top-right',
            autoClose: 3000,
          });
          if (isFromCard) {
            setFromCardInfo(null);
          } else {
            setToCardInfo(null);
          }
        }
      }
    } catch (error: any) {
      toast.error(`${intl.formatMessage({ id: 'FailedToGetCardInfo' }) || 'Failed to get card info'}: ${error?.response?.data?.message || error.message}`, {
        position: 'top-right',
        autoClose: 5000,
      });
      if (isFromCard) {
        setFromCardInfo(null);
      } else {
        setToCardInfo(null);
      }
    } finally {
      if (isFromCard) {
        setIsLoadingFrom(false);
      } else {
        setIsLoadingTo(false);
      }
    }
  };

  // v8: mirrors the DB guards client-side so the clerk sees a problem before
  // submitting. The DB stays the authority — this only saves a round trip.
  // Only evaluated once both cards have been inquired.
  const getGuardHints = (): { message: string; blocking: boolean }[] => {
    if (!fromCardInfo || !toCardInfo) return [];
    const hints: { message: string; blocking: boolean }[] = [];

    if (fromCardInfo.organisation_id !== toCardInfo.organisation_id) {
      hints.push({
        message: intl.formatMessage({ id: 'GuardOrgMismatch' }) ||
          'Both cards must belong to the same issuing organisation.',
        blocking: true,
      });
    }

    if (fromCardInfo.has_owner && toCardInfo.has_owner) {
      hints.push({
        message: intl.formatMessage({ id: 'GuardBothOwned' }) ||
          'These cards belong to two different passengers. Transfer is not allowed.',
        blocking: true,
      });
    }

    if (mode === 'replacement') {
      if (fromCardInfo.has_owner && !toCardInfo.has_owner) {
        hints.push({
          message: intl.formatMessage({ id: 'GuardReplacementDestNoOwner' }) ||
            'The destination card is not linked to a user. Ask the passenger to unlink the old card and link the new one in the mobile app, then retry.',
          blocking: true,
        });
      }
      if (fromCardInfo.has_open_product && !toCardInfo.has_owner) {
        hints.push({
          message: intl.formatMessage({ id: 'GuardReplacementProductDestNoOwner' }) ||
            'The source card holds a fare product, so the destination card must be linked to a user to receive it.',
          blocking: true,
        });
      }
      if (toCardInfo.has_open_product) {
        hints.push({
          message: intl.formatMessage({ id: 'GuardReplacementDestHasProduct' }) ||
            'The destination card already holds a fare product. A card cannot hold more than one.',
          blocking: true,
        });
      }
    } else {
      if (fromCardInfo.has_open_product && !fromCardInfo.has_owner) {
        hints.push({
          message: intl.formatMessage({ id: 'GuardBalanceSourceProductNoOwner' }) ||
            'This card holds a fare product but is not linked to any user. Fix its ownership first.',
          blocking: true,
        });
      }
      const fullBalance = Math.round(Number(fromCardInfo.current_wallet_balance || 0) * 100);
      const enteredAmount = Math.round(Number(wantedAmount || 0) * 100);
      if (fromCardInfo.has_open_product && wantedAmount && enteredAmount === fullBalance) {
        hints.push({
          message: intl.formatMessage({ id: 'GuardBalanceFullAmountWarning' }) ||
            'Moving the entire balance would leave the fare product on an empty card. Either use Card Replacement, or transfer a smaller amount.',
          blocking: false,
        });
      }
    }

    return hints;
  };

  const guardHints = getGuardHints();
  const hasBlockingHint = guardHints.some((h) => h.blocking);

  // Handle transfer
  const handleTransfer = async () => {
    // Validation
    if (!fromCardSerial.trim() || !toCardSerial.trim()) {
      toast.error(intl.formatMessage({ id: 'PleaseEnterBothCardSerials' }) || 'Please enter both card serials', {
        position: 'top-right',
        autoClose: 3000,
      });
      return;
    }



    if (mode === 'balance' && !wantedAmount) {
      toast.error(intl.formatMessage({ id: 'PleaseEnterAmount' }) || 'Please enter amount or select use all balance', {
        position: 'top-right',
        autoClose: 3000,
      });
      return;
    }

    if (hasBlockingHint) {
      toast.error(guardHints.find((h) => h.blocking)?.message, {
        position: 'top-right',
        autoClose: 4000,
      });
      return;
    }

    setIsTransferring(true);

    try {
      const url = `${process.env.REACT_APP_ABT_ALL_APIS_BASE_URL}/api/v1/transactions/transfer_balance`;
      const payload: any = {
        from_serial: fromCardSerial.trim(),
        to_serial: toCardSerial.trim(),
      };

      if (mode === 'replacement') {
        payload.use_all_balance = true;
        payload.make_from_card_blacklisted = true;
        if (blacklistNote.trim()) {
          payload.from_card_blacklisted_note = blacklistNote;
        }
      } else {
        payload.wanted_amount = parseFloat(wantedAmount);
      }

      const response = await axios.post(url, payload, {
        headers: {
          'access-token': loggedInUserAccessTokenClientUid['access-token'],
          'uid': loggedInUserAccessTokenClientUid?.uid,
          'client': loggedInUserAccessTokenClientUid?.client,
        },
      });

      if (response.data.success) {
        toast.success(
          `${intl.formatMessage({ id: 'TransferSuccessful' }) || 'Transfer successful'}! Amount: ${response.data.data.amount}, From New Balance: ${response.data.data.from_new_balance}, To New Balance: ${response.data.data.to_new_balance}`,
          {
            position: 'top-right',
            autoClose: 5000,
          }
        );

        // Reset form
        setFromCardSerial('');
        setToCardSerial('');
        setFromCardInfo(null);
        setToCardInfo(null);
        setMode('balance');
        setBlacklistNote('');
        setWantedAmount('');
      }
    } catch (error: any) {
      toast.error(`${intl.formatMessage({ id: 'TransferFailed' }) || 'Transfer failed'}: ${error?.response?.data?.message || error.message}`, {
        position: 'top-right',
        autoClose: 5000,
      });
    } finally {
      setIsTransferring(false);
    }
  };

  // Small reusable block for the owner/fare-product summary shown on both panels.
  const renderCardStatus = (cardInfo: any) => (
    <>
      <div style={{ fontSize: '13px', marginBottom: '4px' }}>
        <strong>{intl.formatMessage({ id: 'CardOwner' }) || 'Card Owner'}:</strong>{' '}
        {cardInfo.has_owner
          ? `${cardInfo.owner_name || ''}${cardInfo.owner_phone ? ` (${cardInfo.owner_phone})` : ''}`
          : (intl.formatMessage({ id: 'NotLinkedToAnyUser' }) || 'Not linked to any user')}
      </div>
      <div style={{ fontSize: '13px' }}>
        <strong>{intl.formatMessage({ id: 'FareProduct' }) || 'Fare Product'}:</strong>{' '}
        {cardInfo.has_open_product
          ? `${cardInfo.open_product_band_name} (${intl.formatMessage({ id: 'ActivePendingLabel' }) || 'Active/Pending'})`
          : (intl.formatMessage({ id: 'NoFareProduct' }) || 'No fare product')}
      </div>
    </>
  );

  return (
    <div className='dev-contain-all-page-content'>
      <h2 className='header-of-subsystem-page'>
        <OfflineShareIcon style={{ margin: "10px  10px 13px 10px", fontSize: "28px" }} />
        {intl.formatMessage({ id: 'TransferBalance' })}
      </h2>

      <div style={{ padding: '40px 20px 20px 20px', maxWidth: '1200px', margin: '40px auto', backgroundColor: '#F2F3FB', borderRadius: '8px', border: '1px solid lightgray' }}>

        {/* ── Operation mode selector ────────────────────────────────────── */}
        <div style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '8px' }}>
          <div style={{ display: 'flex', gap: '24px', marginBottom: '10px' }}>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="radio"
                name="transfer-mode"
                checked={mode === 'balance'}
                onChange={() => setMode('balance')}
                style={{ marginRight: '8px', width: '18px', height: '18px' }}
              />
              <span>{intl.formatMessage({ id: 'ModeBalanceTransfer' }) || 'Balance Transfer'}</span>
            </label>
            <label style={{ display: 'flex', alignItems: 'center', cursor: 'pointer' }}>
              <input
                type="radio"
                name="transfer-mode"
                checked={mode === 'replacement'}
                onChange={() => setMode('replacement')}
                style={{ marginRight: '8px', width: '18px', height: '18px' }}
              />
              <span>{intl.formatMessage({ id: 'ModeCardReplacement' }) || 'Card Replacement'}</span>
            </label>
          </div>
          <div style={{ fontSize: '13px', color: '#555' }}>
            {mode === 'replacement'
              ? (intl.formatMessage({ id: 'ModeReplacementHint' }) ||
                'The full balance moves, the source card is blacklisted, and any active or pending fare product moves to the destination card.')
              : (intl.formatMessage({ id: 'ModeBalanceTransferHint' }) ||
                'Only the amount entered moves. Any fare product stays on the source card.')}
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
          {/* From/Source Card Section */}
          <div style={{ width: '500px', margin: '15px', border: '1px solid #ddd', borderRadius: '8px', padding: '20px', backgroundColor: '#f9f9f9' }}>
            <h5 style={{ marginBottom: '10px', color: '#333' }}>
              {intl.formatMessage({ id: 'FromSourceCard' }) || 'From/Source Card'}
            </h5>

            <div style={{ display: 'flex', gap: '10px', marginBottom: '15px', alignItems: 'center' }}>
              <input
                type="text"
                value={fromCardSerial}
                onChange={(e) => setFromCardSerial(e.target.value)}
                placeholder={intl.formatMessage({ id: 'EnterCardSerial' }) || 'Enter card serial'}
                style={{
                  flex: 1,
                  padding: '10px',
                  border: '1px solid #ccc',
                  borderRadius: '6px',
                  fontSize: '14px'
                }}
              />
              <button
                className="transfer-info-btn"
                onClick={() => getCardInfo(fromCardSerial, true)}
                disabled={isLoadingFrom}

              >
                {isLoadingFrom ? <CircularProgress size={20} /> : <HelpOutlineIcon />}
              </button>
            </div>

            {/* From Card Info Display */}
            {fromCardInfo && (
              <div style={{ backgroundColor: '#fff', padding: '15px', borderRadius: '4px', border: '1px solid #e0e0e0', marginBottom: '15px' }}>
                {fromCardInfo.blacklist ? (
                  <div style={{ color: '#dc3545', fontSize: '13px', textAlign: 'center' }}>
                    {intl.formatMessage({ id: 'CardBlacklistedTransferError' }) || 'This card is blacklisted and can\'t be used in transfer balance transaction'}
                  </div>
                ) : (
                  <>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '8px' }}>
                      <div><strong>{intl.formatMessage({ id: 'CurrentBalance' }) || 'Current Balance'}:</strong> {fromCardInfo.current_wallet_balance}</div>
                    </div>
                    {renderCardStatus(fromCardInfo)}
                  </>
                )}
              </div>
            )}

            {mode === 'balance' ? (
              <div style={{ marginBottom: '15px' }}>
                <input
                  type="number"
                  value={wantedAmount}
                  onChange={(e) => setWantedAmount(e.target.value)}
                  placeholder={intl.formatMessage({ id: 'EnterAmount' }) || 'Enter amount'}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '4px',
                    fontSize: '14px'
                  }}
                  min="0"
                  step="0.01"
                />
              </div>
            ) : (
              <div style={{ marginTop: '15px' }}>
                <textarea
                  value={blacklistNote}
                  onChange={(e) => setBlacklistNote(e.target.value)}
                  placeholder={intl.formatMessage({ id: 'BlacklistNote' }) || 'Blacklist note (optional)'}
                  style={{
                    width: '100%',
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '6px',
                    minHeight: '60px',
                    fontSize: '14px'
                  }}
                />
              </div>
            )}
          </div>
          <div>
            {/* To/Destination Card Section */}
            <div style={{ width: '500px', margin: '15px 15px 20px 15px', border: '1px solid #ddd', borderRadius: '8px', padding: '20px', backgroundColor: '#f9f9f9' }}>
              <h5 style={{ marginBottom: '10px', color: '#333' }}>
                {intl.formatMessage({ id: 'ToDestinationCard' }) || 'To/Destination Card'}
              </h5>

              <div style={{ display: 'flex', gap: '10px', marginBottom: '15px', alignItems: 'center' }}>
                <input
                  type="text"
                  value={toCardSerial}
                  onChange={(e) => setToCardSerial(e.target.value)}
                  placeholder={intl.formatMessage({ id: 'EnterCardSerial' }) || 'Enter card serial'}
                  style={{
                    flex: 1,
                    padding: '10px',
                    border: '1px solid #ccc',
                    borderRadius: '6px',
                    fontSize: '14px'
                  }}
                />
                <button
                  className="transfer-info-btn"
                  onClick={() => getCardInfo(toCardSerial, false)}
                  disabled={isLoadingTo}

                >
                  {isLoadingTo ? <CircularProgress size={20} /> : <HelpOutlineIcon />}
                </button>
              </div>

              {/* To Card Info Display */}
              {toCardInfo && (
                <div style={{ backgroundColor: '#fff', padding: '15px', borderRadius: '4px', border: '1px solid #e0e0e0', marginBottom: '15px' }}>
                  {toCardInfo.blacklist ? (
                    <div style={{ color: '#dc3545', fontSize: '13px', textAlign: 'center' }}>
                      {intl.formatMessage({ id: 'CardBlacklistedTransferError' }) || 'This card is blacklisted and can\'t be used in transfer balance transaction'}
                    </div>
                  ) : (
                    <>
                      <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginBottom: '8px' }}>
                        <div><strong>{intl.formatMessage({ id: 'CurrentBalance' }) || 'Current Balance'}:</strong> {toCardInfo.current_wallet_balance}</div>
                      </div>
                      {renderCardStatus(toCardInfo)}
                    </>
                  )}
                </div>
              )}

            </div>

            {/* ── Guard hints ─────────────────────────────────────────────── */}
            {guardHints.length > 0 && (
              <div style={{ margin: '0 15px 15px 15px' }}>
                {/*
                  * Keyed on the message, not the array index. getGuardHints()
                  * pushes each hint from its own branch with its own i18n id, so
                  * the message is unique within a render and stable across them
                  * — which an index is not: hints appear and disappear as the
                  * operator edits the amount or swaps a card, and an index key
                  * would let React reuse the wrong node's state and styling.
                  */}
                {guardHints.map((hint) => (
                  <div key={hint.message} style={{
                    padding: '10px',
                    marginBottom: '8px',
                    borderRadius: '6px',
                    fontSize: '13px',
                    backgroundColor: hint.blocking ? '#f8d7da' : '#fff3cd',
                    border: `1px solid ${hint.blocking ? '#dc3545' : '#ffc107'}`,
                    color: hint.blocking ? '#721c24' : '#856404',
                  }}>
                    {hint.message}
                  </div>
                ))}
              </div>
            )}

            {/* Transfer Button */}
            <div style={{ textAlign: 'center' }}>
              <button className="transfer-submit-btn"

                onClick={handleTransfer}
                disabled={isTransferring || hasBlockingHint}

              >
                {isTransferring ? <CircularProgress size={24} style={{ color: '#fff' }} /> : (intl.formatMessage({ id: 'Transfer' }) || 'Transfer')}
              </button>


            </div>
          </div>
        </div>
        <div>


        </div>
      </div>
    </div>
  )
}

export default TransferBalanceForm